module.exports = __webpack_public_path__ + "static/media/yx-title.b41bd5ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/yx-title.png
// module id = 589
// module chunks = 6